import * as React from 'react';
import * as PropTypes from 'prop-types';

import { Item } from './Item';
import { Line } from './Line';
import { PTContentSection } from '../pTypes';
import { useGDPRBannerContext } from '../useGDPRBannerContext';
import { categories } from '../constants';

const FIELD_NAME = 'categories[]';

/**
 * @typedef {import('./Item').ContentSection} ContentSection
 */

/**
 * @typedef {Object} Content
 * @property {ContentSection} essential
 * @property {ContentSection} analytical
 * @property {ContentSection} marketing
 */

function useSelectionState() {
  const [selectionState, setSelectionState] = React.useState({
    [categories.ESSENTIAL]: false,
    [categories.ANALYTICAL]: false,
    [categories.MARKETING]: false,
  });

  const toggleSection = (field) => () =>
    setSelectionState((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));

  return {
    selectionState,
    toggleSection,
  };
}

/**
 * @param {Object} props
 * @param {Content} props.content
 */
export function CookieSelector({ content }) {
  const { state, toggleSelection } = useGDPRBannerContext();
  const { selectionState, toggleSection } = useSelectionState();

  return (
    <div>
      <Line />
      <Item
        name={FIELD_NAME}
        value={categories.ESSENTIAL}
        isOpen={selectionState.essential}
        onClick={toggleSection(categories.ESSENTIAL)}
        isSelected={state.essential}
        content={content.essential}
      />
      <Line />
      <Item
        name={FIELD_NAME}
        value={categories.ANALYTICAL}
        isOpen={selectionState.analytical}
        onClick={toggleSection(categories.ANALYTICAL)}
        isSelected={state.analytical}
        onSelect={toggleSelection(categories.ANALYTICAL)}
        content={content.analytical}
      />
      <Line />
      <Item
        name={FIELD_NAME}
        value={categories.MARKETING}
        isOpen={selectionState.marketing}
        onClick={toggleSection(categories.MARKETING)}
        isSelected={state.marketing}
        onSelect={toggleSelection(categories.MARKETING)}
        content={content.marketing}
      />
      <Line />
    </div>
  );
}

CookieSelector.propTypes = {
  content: PropTypes.shape({
    essential: PTContentSection,
    analytical: PTContentSection,
    marketing: PTContentSection,
  }),
};
